import React, { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import {Container} from 'react-bootstrap'
import MenuKitchen from '../components/menus/MenuKitchen'
import Dashboard from '../pages/kitchen/Dashboard'
import TakeRestaurant from '../pages/kitchen/TakeRestaurant'
import OrdersDashboard from '../pages/kitchen/OrdersDashboard'
import Ordersfordelivery from '../pages/kitchen/Ordersfordelivery'
import Ordersdelivered from '../pages/kitchen/Ordersdelivered'
import Order from '../pages/kitchen/Order'
import OrdersfordeliveryApp from '../pages/kitchen/OrdersfordeliveryApp'

export default function KitchenRouter () {
	const navigate = useNavigate()

    useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (token === 'undefined') {
			navigate('/login')
		}
    }, [navigate])

    return (
        <Container className='contenido kitchen'>
			<MenuKitchen/>
            <Routes>
				<Route path="/dashboard" element={<Dashboard/>}/>
				<Route path="/takerestaurant" element={<TakeRestaurant/>}/>
				<Route path="/ordersfordelivery/:restaurantid" element={<Ordersfordelivery/>}/>
				<Route path="/ordersfordeliveryapp/:restaurantid" element={<OrdersfordeliveryApp/>}/>
				<Route path="/ordersdelivered/:restaurantid" element={<Ordersdelivered/>}/>
				<Route path="/ordersdashboard/:restaurantid" element={<OrdersDashboard/>}/>
				<Route path="/order/:id" element={<Order/>}/>
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </Container>
    )
}